export { TextEllipsis } from './TextEllipsis';
